import "../assets/common2.css";
import { c as s } from "./index.bddf5ebb.js";
const a = "_tag_1t2do_1", _ = "_danger_1t2do_21", c = "_decaffeinato_1t2do_26", e = "_highlight_1t2do_30", i = "_informative_1t2do_34", g = "_success_1t2do_39", d = "_warning_1t2do_44", o = {
  tag: a,
  danger: _,
  decaffeinato: c,
  highlight: e,
  informative: i,
  success: g,
  warning: d
}, h = ({ className: n, variant: t }) => s(o.tag, n, {
  [o[t]]: t !== "default"
});
export {
  h as t
};
//# sourceMappingURL=common.c5b78887.js.map
